const $ = jQuery;

export class Downloads {
    
    constructor(){
        this.save_analitics();
    }

    save_analitics(){
        $('.download_page .button_download').on('click', function(){
            const id_material = $(this).attr('data-id-material');
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: appVars.ajaxUrl,
                data: {
                    action: 'downloadAnalytics',
                    id_material,
                },
                beforeSend: function(){
                },
                error: function(response){
                    console.log(response);
                },
                success: function(response){
                    console.log(response);
                }
            });
        });
    }
}